import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { SpellcheckSuggestionMenuState } from '../../models/sh-editor-overlay.model';

@Component({
    selector: 'sh-editor-spellcheck-menu',
    templateUrl: './sh-editor-spellcheck-menu.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'fixed z-[1100] flex min-w-[180px] max-w-[220px] flex-col gap-1 rounded-[10px] border border-[var(--sh-editor-divider)] bg-[var(--sh-editor-toolbar-bg)] p-2 shadow-[0_12px_24px_rgba(0,0,0,0.28)]',
        'data-sh-editor-spellcheck-menu': 'true',
        'data-testid': 'global-editor-menu-spellcheck',
        '[style.top.px]': 'menu().top',
        '[style.left.px]': 'menu().left',
        '(mousedown)': 'handleMouseDown($event)'
    }
})
export class ShEditorSpellcheckMenuComponent {
    public readonly menu = input.required<SpellcheckSuggestionMenuState>();

    public readonly suggestionSelected = output<string>();

    protected handleMouseDown(event: MouseEvent): void {
        event.preventDefault();
        event.stopPropagation();
    }

    protected selectSuggestion(event: MouseEvent, suggestion: string): void {
        event.preventDefault();
        event.stopPropagation();
        this.suggestionSelected.emit(suggestion);
    }

    protected suggestionTestId(suggestion: string): string {
        return `global-editor-menu-option-${suggestion
            .trim()
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '')}`;
    }
}
